import HeroSection from "../sections/home/HeroSection";
import WhatWeDoSection from "../sections/home/WhatWeDoSection";
import ProcessSection from "../sections/home/ProcessSection";

export default function HomePage() {
  return (
    <div>
      <HeroSection />
      <WhatWeDoSection />
      <ProcessSection />
    </div>
  );
}
